import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AuthService} from "../../../services/auth.service";
import {SecondaryButtonComponent} from '../../buttons/secondary-button/secondary-button.component';
import {PrimaryButtonComponent} from '../../buttons/primary-button/primary-button.component';
import {ToggleComponent} from '../../toggle/toggle.component';
import {TranslocoModule} from '@jsverse/transloco';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import { GoogleAnalyticsService } from "../../../services/googleAnalytics.service";
import {CompanyInfo} from "../../../types/company-info";
import {PortalSettings} from "../../../types/portalSettings";
import {CookieSettings} from "../../../types/cookieSettings";
import {logger} from '../../../services/logging.service';

@Component({
    selector: 'app-cookie-settings',
    templateUrl: './cookie-settings.component.html',
    styleUrl: './cookie-settings.component.css',
    standalone: true,
    imports: [MatIconButton, MatIcon, TranslocoModule, ToggleComponent, PrimaryButtonComponent, SecondaryButtonComponent]
})
export class CookieSettingsComponent {

    gAId: string = "";
    public statisticCookies: boolean = false;
    public marketingCookies: boolean = false;

    sanitizedHtmlNote!: string;

    cookieSettings: CookieSettings;
    companyInfo: CompanyInfo = CompanyInfo.getEmpty();
    portalSettings: PortalSettings = PortalSettings.getEmpty();

    constructor(public dialogRef: MatDialogRef<CookieSettingsComponent>,
                public authService: AuthService,
                private googleAnalyticsService: GoogleAnalyticsService,
                @Inject(MAT_DIALOG_DATA) public data: any ) {
        this.statisticCookies = data.statisticCookies || false;
        this.marketingCookies = data.marketingCookies || false;
        this.cookieSettings = new CookieSettings()
    }

    async ngOnInit() {
        await this.loadCompanyInfo();
        this.sanitizedHtmlNote = this.cookieSettings.cookieSettingsModalNote;
        logger.debug(this.sanitizedHtmlNote);
    }

    async loadCompanyInfo() {
        await this.authService.loadBrandFromDatabase(this.authService.brandName);
        this.companyInfo = this.authService.companyData.companyInfo;
        this.portalSettings = this.authService.companyData.portalSettings;
        try {
            await this.authService.loadPortalSettingsFromDatabase();
            this.cookieSettings = this.authService.companyData?.portalSettings?.cookieSettings || null;
        } catch (error) {
            logger.error('error', error);
        }
    }

    close(): void {
        this.dialogRef.close();
    }

    onAcceptAllCookies() {
        if (this.authService.companyData.portalSettings.useGoogleAnalytics) {
            this.googleAnalyticsService.enableTracking();
        }
        this.dialogRef.close({ statisticCookies: true, marketingCookies: true });
    }

    onAcceptSelectedCookies() {
        if (this.statisticCookies && this.authService.companyData.portalSettings.useGoogleAnalytics) {
            this.googleAnalyticsService.enableTracking();
        } else {
            this.googleAnalyticsService.disableTracking();
        }
        this.dialogRef.close({ statisticCookies: this.statisticCookies, marketingCookies: this.marketingCookies });
    }

    onDeclineCookies() {
        this.googleAnalyticsService.disableTracking();
        this.dialogRef.close({ statisticCookies: false, marketingCookies: false });
    }

}
